import { useState, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import { useCardsStore } from '@lib/store';
import { AddItemEnum, type GetCardsResponse } from '@shared/api';
import { CardSlideItem } from './widgets';
import { AddNewItemModal, SlideAdd, SlideItem, TransferToCardModal } from '@widgets';
import './CardsSlider.scss';

const settings = {
  dots: false,
  arrows: true,
  infinite: false,
  speed: 800,
  slidesToShow: 3,
  slidesToScroll: 1,
  variableWidth: false,
  adaptiveHeight: true,
  cssEase: 'ease-out',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '0',
        variableWidth: false,
        adaptiveHeight: true,
      },
    },
  ],
};

interface CardsSliderProps {
  isVisibleDownloadButton?: boolean;
}

export const CardsSlider = (props: CardsSliderProps) => {
  const cardStore = useCardsStore();

  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [isVisibleModal, setIsVisibleModal] = useState<boolean>(false);
  const [slideWidth, setSlideWidth] = useState<number>(390);
  const [isVisibleTransferToCardModal, setIsVisibleTransferToCardModal] = useState<boolean>(false);
  const [selectedCard, setSelectedCard] = useState<GetCardsResponse>();
  const sliderWrapRef = useRef<HTMLDivElement | null>(null);
  const sliderRef = useRef<any | null>(null);

  useEffect(() => {
    const updateDimensions = () => {
      if (!sliderWrapRef.current || !sliderRef.current) return;
      const currentSettings = sliderRef.current.innerSlider?.props;
      const currentSlidesToShow = currentSettings.slidesToShow;
      setIsMobile(currentSlidesToShow === 1);
      const sliderWidth = sliderWrapRef.current.clientWidth;
      setSlideWidth(sliderWidth / currentSlidesToShow);
    };

    const timer = setTimeout(updateDimensions, 50);
    window.addEventListener('resize', updateDimensions);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('resize', updateDimensions);
    };
  }, []);

  const width = isMobile ? slideWidth : slideWidth + (window.innerWidth > 1024 ? 22 : 14);
  const height = isMobile ? 300 : slideWidth > 350 ? 350 : slideWidth;
  return (
    <div ref={sliderWrapRef} className='mt-10'>
      <Slider ref={sliderRef} className='sliderAnimation slider-cards cursor-pointer text-center' {...settings}>
        {cardStore.data.map((card) => (
          <SlideItem
            key={card.Id}
            card={card}
            onSelectedCard={setSelectedCard}
            className={`min-h-[353px] max-w-[400px] px-2`}
            style={{ width: width, height: height }}
          >
            <CardSlideItem
              card={card}
              selectedCard={selectedCard}
              isVisibleDownloadButton={props.isVisibleDownloadButton}
              onSelectedCard={setSelectedCard}
              onShowTransferToCardModal={() => setIsVisibleTransferToCardModal(true)}
            />
          </SlideItem>
        ))}
        <SlideAdd
          className={`mb-[19px] max-w-[400px]`}
          style={{ width: width, height: height }}
          text='Add card'
          onClick={() => setIsVisibleModal(true)}
        />
      </Slider>
      <AddNewItemModal isOpen={isVisibleModal} onClose={() => setIsVisibleModal(false)} type={AddItemEnum.Card} />
      <TransferToCardModal isOpen={isVisibleTransferToCardModal} onClose={() => setIsVisibleTransferToCardModal(false)} selectedCard={selectedCard} />
    </div>
  );
};
